import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import PreloaderCircle from 'src/components/ui/PreloaderCircle'
import LocationPane from '../../../containers/riders/editrider/LocationPane'
import MembershipPane from '../../../containers/riders/editrider/MembershipPane'
import PersonalInfoPane from '../../../containers/riders/editrider/PersonalInfoPane'
import WalletPane from '../../../containers/riders/editrider/WalletPane'
import { IRiderObject, IStateMetadata } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import EditRiderStepSelector from './RiderProfileEditStepSelector'

interface IRiderProfileEditProps {
  metadata: IStateMetadata
  riders: { [key: number]: IRiderObject }
  loading: boolean
  match: any
  activate: (rider: IRiderObject) => void
  deactivate: (rider: IRiderObject) => void
  moveToArchive: (rider: IRiderObject) => void
  getRiderPersonalInfo: (riderId: string) => void
}

interface IRiderProfileEditState {
  currentError: { isError: boolean; message: string }
  isLoading: boolean
}

const RiderProfileEditStepsPane = ({ location, match, metadata, rider, showMessage }: any) => {
  const riderId = match.params.id

  const personalInfoPane = (props: any) => (
    <PersonalInfoPane id={riderId} rider={rider} metadata={metadata} showMessage={showMessage} {...props} />
  )
  const locationPane = (props: any) => (
    <LocationPane riderId={riderId} metadata={metadata} showMessage={showMessage} {...props} />
  )
  const membershipPane = (props: any) => (
    <MembershipPane riderId={riderId} metadata={metadata} showMessage={showMessage} {...props} />
  )
  const walletPane = (props: any) => (
    <WalletPane rider={rider} metadata={metadata} showMessage={showMessage} {...props} />
  )

  return (
    <div className=''>
      <EditRiderStepSelector pathname={location.pathname} riderId={riderId} />
      <Switch>
        <Route path={`/riders/${riderId}/edit/profile`} render={personalInfoPane} />
        <Route path={`/riders/${riderId}/edit/location`} render={locationPane} />
        <Route path={`/riders/${riderId}/edit/membership`} render={membershipPane} />
        <Route path={`/riders/${riderId}/edit/wallet`} render={walletPane} />
      </Switch>
    </div>
  )
}

class RiderProfileEdit extends React.Component<IRiderProfileEditProps, IRiderProfileEditState> {
  constructor(props: IRiderProfileEditProps) {
    super(props)
    this.state = {
      currentError: { isError: false, message: '' },
      isLoading: true
    }
  }

  public async componentDidMount() {
    try {
      await this.props.getRiderPersonalInfo(this.props.match.params.id)
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  public componentDidUpdate(prevProps: IRiderProfileEditProps) {
    if (prevProps.metadata !== this.props.metadata) {
      const { processingError, processingSuccess } = this.props.metadata
      if (processingError) {
        this.showMessage(processingError, true)
      }
      if (processingSuccess) {
        this.showMessage(processingSuccess, false)
      }
    }
  }

  public render() {
    const rider = this.props.riders[this.props.match.params.id]
    const fullName = rider ? `${rider.firstName} ${rider.lastName}` : ''
    const isActive = rider && rider.isActive
    const { message, isError } = this.state.currentError

    const styles = {
      CirclePreLoader: {
        display: 'flex',
        paddingTop: '5px',
        flex: 1,
        justifyContent: 'center',
        alignment: 'center',
        width: '100%'
      }
    }

    if (this.state.isLoading) {
      return (
        <div style={styles.CirclePreLoader}>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    return (
      <section>
        <div>
          {message.length > 0 && (
            <div className={'pr1 pl3 pt1 pb1 font-white ' + (isError ? 'bg-red' : 'bg-green')}>{message}</div>
          )}
          <div className='form-title-header'>
            <div>
              <span className='h3'>{`${UIMessages.common.edit} ${fullName}`}</span>
              <span className='ml2 h6 font-light-blue-grey'>
                {UIMessages.common.status}: {isActive ? UIMessages.common.active : UIMessages.common.inactive}
              </span>
            </div>
          </div>
          <RiderProfileEditStepsPane rider={rider} showMessage={this.showMessage} {...this.props} />
        </div>
      </section>
    )
  }

  private onActivate = (rider: IRiderObject) => {
    this.props.activate(rider)
  }

  private onDeactivate = (rider: IRiderObject) => {
    this.props.deactivate(rider)
  }

  private onMoveToArchive = (rider: IRiderObject) => () => {
    this.props.moveToArchive(rider)
  }

  private onActivateToggle = (rider: IRiderObject) => () => {
    rider.isActive ? this.onDeactivate(rider) : this.onActivate(rider)
  }

  private showMessage = (message: string, isError: boolean) => {
    if (this.state.currentError.message === message) {
      return
    }
    this.setState({ currentError: { message, isError } })
  }
}

export default RiderProfileEdit



// WEBPACK FOOTER //
// ./src/components/riders/editrider/RiderProfileEditPane.tsx